// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__7fJtE","footer__inner":"styles_footer__inner__EglC_","footer__menu":"styles_footer__menu__AIkA8"};